import React from "react";

import AvatarBlock from "components/avatar";
import UserStatusBadge from "components/user-status-badge";


const UserAvatar = ({ user, labelPrefix = "", statusVariant = "compact" }) => {
    const award = user.best_salesman && statusVariant === "award";

    const avatar = (
        <AvatarBlock
            photoUrl={ user.avatar }
            blocked={ user.status === "block" ? "normal" : null }
            initials={ user.initials }
            link={`/${ user.nickname }`}
            label={`${ labelPrefix }${ user.nickname }`}
            text={ user.status === "block" ? "Inactive user" : user.name }
            diamondStatus={ user.diamond_status }
            bestSalesman={ user.best_salesman }
            showStatus={ !award }
            size={50}
        />
    );

    return award ? (
        <div className="user-avatar-award">
            {avatar}
            <UserStatusBadge
                diamondStatus={user.diamond_status}
                bestSalesman={user.best_salesman}
                variant="award"
            />
        </div>
    ) : avatar;
};

export default UserAvatar;
